<template>
    <dialog closedby="any" ref="dialog" data-swiftype-index="false" class="calendar-popup" @close="emit('close')">
        <div class="calendar-popup__inner" v-if="event">
            <button type="button" class="calendar-popup__close" aria-label="Close performance details" @click="closeDialog">
                <svg class="calendar-popup__close-icon" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 39 39" fill="none">
                    <g clip-path="url(#clip0_838_2052)">
                        <path d="M19.2858 21.0886L25.8428 27.6456C25.9583 27.7643 26.0964 27.8588 26.2489 27.9234C26.4014 27.9879 26.5653 28.0214 26.7309 28.0217C26.9 28.0258 27.0682 27.9945 27.2244 27.9297C27.3807 27.865 27.5217 27.7682 27.6383 27.6456C27.7602 27.5299 27.8573 27.3906 27.9237 27.2362C27.9901 27.0818 28.0243 26.9155 28.0243 26.7474C28.0243 26.5793 27.9901 26.413 27.9237 26.2586C27.8573 26.1041 27.7602 25.9648 27.6383 25.8492L21.0813 19.2921L27.6383 12.7351C27.757 12.6196 27.8515 12.4816 27.9161 12.329C27.9806 12.1765 28.0141 12.0126 28.0144 11.847C28.0192 11.6778 27.9882 11.5095 27.9234 11.3531C27.8586 11.1967 27.7614 11.0558 27.6383 10.9396C27.5229 10.8173 27.3838 10.7199 27.2294 10.6533C27.075 10.5867 26.9087 10.5524 26.7406 10.5524C26.5724 10.5524 26.4061 10.5867 26.2517 10.6533C26.0973 10.7199 25.9582 10.8173 25.8428 10.9396L19.2858 17.4967L12.7288 10.9396C12.613 10.8211 12.475 10.7266 12.3226 10.6617C12.1701 10.5968 12.0063 10.5628 11.8407 10.5616C11.6714 10.5575 11.5031 10.589 11.3468 10.6541C11.1904 10.7192 11.0496 10.8165 10.9333 10.9396C10.8113 11.0551 10.7141 11.1943 10.6476 11.3487C10.5812 11.503 10.5469 11.6693 10.5469 11.8374C10.5469 12.0054 10.5812 12.1717 10.6476 12.326C10.7141 12.4804 10.8113 12.6196 10.9333 12.7351L17.4903 19.2921L10.9333 25.8492C10.8145 25.9648 10.72 26.103 10.6554 26.2557C10.5908 26.4084 10.5574 26.5724 10.5572 26.7382C10.5526 26.9074 10.5837 27.0757 10.6485 27.232C10.7133 27.3884 10.8103 27.5293 10.9333 27.6456C11.0488 27.7676 11.188 27.8648 11.3424 27.9313C11.4967 27.9977 11.663 28.0319 11.831 28.0319C11.9991 28.0319 12.1653 27.9977 12.3197 27.9313C12.474 27.8648 12.6132 27.7676 12.7288 27.6456L19.2858 21.0886ZM19.2858 38.5775C16.7097 38.5932 14.1582 38.0761 11.7915 37.0588C7.16712 35.0944 3.4848 31.4131 1.51912 26.7893C0.500679 24.4219 -0.0164225 21.8692 0.000397538 19.2921C-0.0163569 16.7073 0.500332 14.1469 1.51816 11.7708C2.49124 9.48327 3.89646 7.40491 5.6568 5.64964C7.42221 3.90014 9.50318 2.50105 11.7896 1.52642C14.1566 0.507643 16.7089 -0.00978982 19.2858 0.006732C21.8707 -0.00980093 24.4312 0.507221 26.8071 1.52546C31.4259 3.47636 35.1016 7.152 37.0525 11.7708C38.0715 14.1465 38.5886 16.7072 38.5712 19.2921C38.5869 21.8681 38.0702 24.4196 37.0534 26.7864C36.0785 29.0733 34.6799 31.1551 32.9312 32.9221C31.1745 34.6819 29.0953 36.0867 26.8071 37.0598C24.4312 38.078 21.8706 38.5947 19.2858 38.5775ZM19.2858 36.027C21.4915 36.0678 23.682 35.6556 25.7221 34.816C27.7621 33.9765 29.6082 32.7273 31.1463 31.1459C32.7244 29.607 33.9709 27.7616 34.8091 25.723C35.6474 23.6845 36.0597 21.496 36.0207 19.2921C36.0613 17.0871 35.6497 14.8971 34.8114 12.8572C33.973 10.8174 32.7257 8.97088 31.1463 7.43161C29.6071 5.85207 27.7607 4.60465 25.7208 3.76631C23.6809 2.92796 21.4909 2.51647 19.2858 2.55723C17.082 2.5182 14.8935 2.9305 12.8549 3.76877C10.8164 4.60704 8.97089 5.85355 7.43202 7.43161C5.85048 8.96961 4.60129 10.8157 3.76172 12.8558C2.92214 14.8958 2.51004 17.0864 2.55089 19.2921C2.51146 21.4968 2.92424 23.6861 3.76376 25.725C4.60327 27.7639 5.85171 29.6092 7.43202 31.1469C8.96979 32.7268 10.8149 33.975 12.8536 34.8145C14.8923 35.654 17.0814 36.066 19.2858 36.027Z" fill="currentcolor"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_838_2052">
                        <rect width="38.5716" height="38.5843" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>

            <div class="calendar-popup__item">
                <div v-if="event.event.image?.src" class="calendar-popup-item__media">
                    <button type="button" class="calendar-popup-item__favourites" aria-label="Add to favourites" v-if="props.enableFavorites">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path d="M6.61006 25.874C6.86188 26.0739 7.18107 26.046 7.61328 25.7177L13.999 20.8198L20.3879 25.7177C20.8201 26.046 21.1362 26.0739 21.3911 25.874C21.6511 25.6774 21.7366 25.3546 21.5679 24.8055L19.0999 16.9343L25.5178 12.0787C25.95 11.7536 26.0617 11.4305 25.9704 11.1196C25.879 10.8069 25.6001 10.6197 25.0553 10.6197H17.1559L14.7359 2.7605C14.5623 2.21654 14.3182 2 13.999 2C13.683 2 13.4389 2.21654 13.2653 2.7605L10.8452 10.6197H2.9459C2.40112 10.6197 2.12217 10.8069 2.03084 11.1196C1.93635 11.4305 2.05119 11.7536 2.4834 12.0787L8.90124 16.9343L6.43329 24.8055C6.26465 25.3546 6.3501 25.6774 6.61006 25.874Z" fill="black" fill-opacity="0.85"/>
                            <path d="M13.999 1C14.4177 1 14.814 1.15514 15.1279 1.46777C15.4098 1.74854 15.5774 2.10823 15.6885 2.45605L15.6914 2.46582L17.8945 9.62012H25.0557C25.4292 9.62016 25.8276 9.68201 26.1816 9.88574C26.5653 10.1065 26.8162 10.4474 26.9307 10.8389H26.9297C27.0379 11.2078 27.026 11.6096 26.8555 11.9971C26.6945 12.3626 26.4221 12.6501 26.1191 12.8779L26.1182 12.877L20.2637 17.3066L22.5225 24.5059L22.5234 24.5117C22.6337 24.8706 22.6971 25.2642 22.623 25.6572C22.5433 26.0803 22.3188 26.4194 22.0068 26.6602L22.0078 26.6611C22.0061 26.6625 22.0036 26.6627 22.002 26.6641C21.9992 26.6662 21.9969 26.6698 21.9941 26.6719L21.9932 26.6709C21.6678 26.9205 21.2613 27.0464 20.8174 26.9844C20.4144 26.928 20.0671 26.7294 19.7832 26.5137L19.7793 26.5117L13.999 22.0791L8.22168 26.5107L8.21777 26.5137C7.93262 26.7303 7.58427 26.9283 7.18164 26.9844C6.74087 27.0457 6.33352 26.923 6.00684 26.6709V26.6719C6.00247 26.6686 5.99847 26.6645 5.99414 26.6611C5.99231 26.6597 5.99011 26.6587 5.98828 26.6572V26.6562C5.6792 26.4157 5.45718 26.0777 5.37793 25.6572C5.30387 25.2643 5.36735 24.8705 5.47754 24.5117L5.47949 24.5059L7.73633 17.3066L1.87988 12.876L1.88086 12.875C1.58012 12.6484 1.30695 12.3629 1.14551 11.998C0.97485 11.6122 0.96123 11.2102 1.07227 10.8379C1.18684 10.447 1.43624 10.1063 1.81934 9.88574C2.17353 9.68193 2.57265 9.62012 2.94629 9.62012H10.1064L12.3096 2.46582L12.3125 2.45605C12.4236 2.10805 12.5915 1.74909 12.8721 1.46875C13.1842 1.15693 13.5794 1 13.999 1Z" stroke="white" stroke-opacity="0.7" stroke-width="2"/>
                        </svg>
                    </button>
                    <div class="calendar-popup-item__intrinsic-ratio">
                        <!-- Intentionally empty alt to avoid SR clutter -->
                        <img :src="event.event.image.src" alt class="calendar-popup-item__image" width="540" height="405" />
                    </div>
                </div>

                <!-- Performance Details Section -->
                <div class="calendar-popup-performance">
                    <div class="calendar-popup-performance__header"></div>

                    <div class="calendar-popup-performance__body">
                        <span class="calendar-popup-performance__meta">
                            <span class="calendar-popup-performance__date">{{ formatDate(event.performancedate) }}</span>
                            <span v-if="event.event.venue?.title" class="calendar-popup-performance__venue">
                            on the <strong>{{ event.event.venue.title }}</strong>
                            </span>
                            <span class="calendar-popup-performance__time"> at {{ formatTime(event.performancedate) }}</span>
                        </span>
                        <div class="calendar-popup-performance__titles">
                            <hgroup class="calendar-popup-performance__heading">
                                <span class="calendar-popup-performance__prefix">{{ event.prefix }}</span>
                                <h2 class="calendar-popup-performance__title" v-html="event.title"></h2>
                                <span class="calendar-popup-performance__suffix">{{ event.suffix }}</span>
                            </hgroup>
                            <span v-if="event.event.attributes?.custom?.composer" class="calendar-popup-performance__suffix">
                                {{ event.event.attributes.custom.composer }}
                            </span>
                        </div>
                        <div v-if="event.description" class="calendar-popup-performance__description">
                            <p v-html="event.description"></p>
                        </div>

                        <h5 v-if="event.attributes.custom?.subtitle" class="calendar-popup-performance__subtitle">
                            {{ event.attributes.custom.subtitle }}
                        </h5>

                        <div v-if="event.attributes.custom?.details" class="calendar-popup-performance__details"
                            v-html="event.attributes.custom.details"></div>

                        <!-- @todo awaiting confirmation of where this data is from -->
                        <span v-if="event.attributes.custom?.repertory" class="calendar-popup-performance__repertory">
                            {{ event.attributes.custom.repertory }}
                        </span>

                         <ul v-if="event.event.attributes?.custom?.genres?.length" class="calendar-popup-performance__genres">
                            <li v-for="(genre, idx) in event.event.attributes.custom.genres"
                                :key="idx" class="calendar-list-event__genre-badge">
                                {{ genre }}
                            </li>
                        </ul>
                    </div>

                    <div class="calendar-popup-performance__footer">
                        <div class="calendar-popup-performance__footer--cta">
                            <a v-if="event.event.url" :href="event.event.url"
                                class="calendar-popup-performance__secondary-action btn btn--outline">
                                More Info
                            </a>
                            <a v-if="event.ctaPrimary" :href="event.ctaPrimary.link"
                                class="calendar-popup-performance__primary-action btn btn--black">
                                {{ event.ctaPrimary.title }}
                            </a>
                            <a v-if="event.isSoldOut"
                                class="calendar-popup-performance__primary-action btn btn--black">
                                Sold Out
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="calendar-popup__footer">
                <div class="calendar-popup__footer--cta">
                    <a v-if="event.event.url" :href="event.event.url"
                        class="calendar-popup-performance__secondary-action btn btn--outline">
                        More Info
                    </a>
                    <template v-if="!props.disableBookButtons">
                        <a v-if="event.ctaPrimary" :href="event.ctaPrimary.link"
                            class="calendar-popup-performance__primary-action btn btn--black">
                            {{ event.ctaPrimary.title }}
                        </a>
                        <a v-if="event.isSoldOut"
                            class="calendar-popup-performance__primary-action btn--black">
                            Sold Out
                        </a>
                    </template>
                </div>
                <ul v-if="event.event.attributes?.custom?.genres?.length" class="calendar-popup__footer--genres">
                    <li v-for="(genre, idx) in event.event.attributes.custom.genres"
                        :key="idx" class="calendar-popup__footer--genre-badge">
                        {{ genre }}
                    </li>
                </ul>
            </div>
        </div>
    </dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

const emit = defineEmits(['close']);

const props = defineProps({
    event: {
        type: Object,
        default: null,
    },
    formatDate: {
        type: Function,
        required: true,
    },
    formatTime: {
        type: Function,
        required: true,
    },
    disableBookButtons: {
        type: Boolean,
        default: false,
    },
    enableFavorites: {
        type: Boolean,
        default: true,
    },
});

const dialog = ref(null);

const closeDialog = () => {
    dialog.value?.close();
    emit('close');
};

watch(() => props.event, (newEvent) => {
    if (newEvent) {
        dialog.value?.showModal();
    }
});
</script>
